import { Layers, Camera, UtensilsCrossed, BadgeCheck } from "lucide-react";
import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const BENEFITS = [
  {
    icon: Layers,
    title: "Strategic Case Rooms",
    body: "Two team simulations based on realistic operational, business and market challenges, with clear instructions and structured feedback.",
  },
  {
    icon: Camera,
    title: "Professional Headshot",
    body: "A clean professional portrait for LinkedIn and other career platforms.",
  },
  {
    icon: UtensilsCrossed,
    title: "Working Lunch & Networking",
    body: "Lunch at your table, with time to connect with people who are serious about learning and building.",
  },
  {
    icon: BadgeCheck,
    title: "Certificate of Completion",
    body: "For delegates who complete the programme and its required activities.",
  },
];

export default function Experience() {
  return (
    <section id="experience">
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">The delegate experience</div>
          <h2 className="title">Come ready to work. Leave with more than notes.</h2>
          <ThemeTag />
          <p className="intro">
            Selected delegates will take part in a professionally organised experience
            built around learning, useful connections and tools they can keep using.
          </p>
        </Reveal>
        <div className="benefits">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.08} className="benefit" data-testid="delegate-benefit-card">
              <div className="ico">
                <b.icon size={19} strokeWidth={2} />
              </div>
              <div>
                <h3>{b.title}</h3>
                <p>{b.body}</p>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.4} className="benefit benefit-photo frame">
            <img
              src="https://images.unsplash.com/photo-1653566031587-74f7d86a2e71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1OTN8MHwxfHNlYXJjaHw0fHxOaWdlcmlhbiUyMGJ1c2luZXNzJTIwdGVhbSUyMGNvcnBvcmF0ZSUyMHN0cmF0ZWd5JTIwd29ya3Nob3AlMjBib2FyZHxlbnwwfHx8fDE3OTI1MjgyNDh8MA&ixlib=rb-4.1.0&q=85"
              alt="Delegates collaborating on strategic execution framework"
              loading="lazy"
            />
            <span className="frame-tag">Inside the case room</span>
          </Reveal>
        </div>
        <p className="hint">
          Travel support is planned, subject to final funding and the published delegate
          policy. Final benefits will be confirmed before admission is offered.
        </p>
      </div>
    </section>
  );
}
